/* ============================================================
   assets/senchado-article-sticky-buy.js
   記事ページのスティッキー購入カードの制御。
   出典: prototype/article-sticky-buy-mockup.html
   仕様: docs/spec-uriba-article-quote.md §5.2

   振る舞い:
     - ファーストビューから表示（谷本さん決裁 2026-07-28・ヒーロー通過待ちは廃止）
     - ×（閉じる）は廃止（§2.1 決裁8・2026-07-28 実機FB）。「上に戻る」FABと重なるため。
       退避は下の自動退避だけが担い、sessionStorage による抑止も持たない。
     - 記事末尾の商品モジュール（.senchado-article-products）が「十分に見えたら」退避。
       端が1pxかすった時点で消えると記事が短い場合に生存区間が痩せるため、
       IntersectionObserver の rootMargin で下端 120px 手前まで引きつける。
     - CTA は実カート追加（/cart/add.js）。送信中ロック・二重クリック防止・
       失敗時「追加できませんでした」表示。成功時は既存のカート機構の経路
       （cart:updated dispatch → cart-drawer.renderContents）に乗せる。
     - <cart-drawer> 非搭載・#cart-icon-bubble 非搭載でも落ちないよう null ガードする。
     - prefers-reduced-motion は CSS 側で transition を切る（JS は関与しない）。
   ============================================================ */
(function () {
  'use strict';

  if (typeof window === 'undefined') return;
  // 二重ロード防止（senchado-cart.js と同じ冪等ガード）: listener の二重登録による
  // /cart/add.js の二重POSTを防ぐ。
  if (window.__scArticleStickyBuyInit) return;
  window.__scArticleStickyBuyInit = true;

  var SELECTOR_STICKY = '[data-sticky-buy]';
  var SELECTOR_CTA = '[data-sticky-add-to-cart]';
  // 退避先: 記事末尾の商品モジュール（sections/senchado-article-products.liquid）。
  // [data-sticky-buy-yield] は将来別の要素にも譲らせたい時の追加フック。
  var SELECTOR_YIELD = '.senchado-article-products, [data-sticky-buy-yield]';
  var YIELD_MARGIN = '0px 0px -120px 0px';
  var YIELD_MARGIN_PX = 120;
  var BODY_SHOWN_CLASS = 'sc-sticky-buy-shown';

  var LABEL_LOADING = '追加中...';
  var LABEL_SUCCESS = 'カートに追加しました';
  var LABEL_ERROR = '追加できませんでした';
  var RESET_DELAY = 2000;

  function addToCart(button) {
    // 再入防止: disabled で native click は止まるが、disabled を外された場合や
    // 合成イベントでも二重POSTしないようフラグでも塞ぐ。
    if (button.disabled || button.dataset.loading === 'true') return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    if (!button.dataset.label) button.dataset.label = button.textContent;
    var original = button.dataset.label;

    button.dataset.loading = 'true';
    button.disabled = true;
    button.dataset.state = 'loading';
    button.textContent = LABEL_LOADING;

    // ドロワー非搭載テーマでも落ちないよう null ガード。
    var drawer = document.querySelector('cart-drawer');
    var payload = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (drawer) {
      // #cart-icon-bubble はこのテーマのヘッダーに無いが、cart-drawer.renderContents 側が
      // 要素不在を握るため要求しても安全（senchado-cart.js と同じ作法）。
      payload.sections = 'cart-drawer,cart-icon-bubble';
      payload.sections_url = window.location.pathname;
    }

    function restore() {
      window.setTimeout(function () {
        button.textContent = original;
        delete button.dataset.state;
        button.disabled = false;
        button.dataset.loading = 'false';
      }, RESET_DELAY);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart_add_failed:' + res.status);
        return res.json();
      })
      .then(function (data) {
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        button.dataset.state = 'success';
        button.textContent = LABEL_SUCCESS;

        if (drawer) {
          try {
            var sections = data && data.sections;
            if (sections && sections['cart-drawer'] && typeof drawer.renderContents === 'function') {
              drawer.renderContents(data);
            } else if (typeof drawer.open === 'function') {
              drawer.open();
            }
          } catch (_) {
            /* ドロワー描画の失敗はカート追加自体を巻き戻さない */
          }
        }
        restore();
      })
      .catch(function () {
        button.dataset.state = 'error';
        button.textContent = LABEL_ERROR;
        restore();
      });
  }

  function init() {
    var sticky = document.querySelector(SELECTOR_STICKY);
    if (!sticky) return;

    var cta = sticky.querySelector(SELECTOR_CTA);

    // 表示/非表示を決めるのは自動退避だけ（手動クローズは廃止）。
    var yielded = false;

    function update() {
      var show = !yielded;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      // SP でスクロールトップFABをバーの上へ逃がすための状態クラス（CSS 側で使用）。
      if (document.body) document.body.classList.toggle(BODY_SHOWN_CLASS, show);
    }

    if (cta) {
      cta.addEventListener('click', function (event) {
        event.preventDefault();
        addToCart(cta);
      });
    }

    var targets = document.querySelectorAll(SELECTOR_YIELD);

    if (targets.length) {
      if ('IntersectionObserver' in window) {
        // 交差中の要素集合（Set 非依存＝配列で保持し ES5 互換を保つ）。
        var visible = [];

        var mark = function (el, isVisible) {
          var i = visible.indexOf(el);
          if (isVisible && i === -1) visible.push(el);
          if (!isVisible && i !== -1) visible.splice(i, 1);
        };

        // 初期状態を同期反映（監視開始前）: 短い記事で末尾モジュールが最初から
        // 視界内にある場合に、初回コールバックまでの一瞬だけ出るチラつきを防ぐ。
        var vh0 = window.innerHeight || document.documentElement.clientHeight;
        Array.prototype.forEach.call(targets, function (el) {
          var rect = el.getBoundingClientRect();
          mark(el, rect.top < vh0 - YIELD_MARGIN_PX && rect.bottom > 0);
        });
        yielded = visible.length > 0;

        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              mark(entry.target, entry.isIntersecting);
            });
            yielded = visible.length > 0;
            update();
          },
          { threshold: 0, rootMargin: YIELD_MARGIN }
        );

        Array.prototype.forEach.call(targets, function (el) {
          observer.observe(el);
        });
      } else {
        // フォールバック（IntersectionObserver 非対応）
        var onScroll = function () {
          var vh = window.innerHeight || document.documentElement.clientHeight;
          var anyVisible = false;
          Array.prototype.forEach.call(targets, function (el) {
            var rect = el.getBoundingClientRect();
            if (rect.top < vh - YIELD_MARGIN_PX && rect.bottom > 0) anyVisible = true;
          });
          yielded = anyVisible;
          update();
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        onScroll();
      }
    }

    // ファーストビューから表示（IntersectionObserver の初回コールバックを待たない）。
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
